import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ComponentDefinition} from '@formbird/types';
import {ChangedDocumentService} from 'formbird-services';
import {FormArray, FormControl, Validators} from '@angular/forms';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {MatTooltip} from '@angular/material/tooltip';
import {MatFormField} from '@angular/material/form-field';
import {FormbirdInjectorService} from '@services/injector/formbird-injector.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

interface CheckListCommentComponentDefinition extends ComponentDefinition {
  list?: string[];
}

@Component({
  templateUrl: './checklist-comment.component.html',
  styleUrls: ['./checklist-comment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CheckListCommentComponent extends AbstractComponent<CheckListCommentComponentDefinition> implements OnInit {

  checkList: any;
  checkListCommentControlTextField: any;
  commentItemList: any = [];
  user: any;

  loggedInUserService: any;

  constructor(
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef,
    protected formbirdInjectorService: FormbirdInjectorService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.user = this.loggedInUserService.user.account;
  }

  ngOnInit() {

    this.componentSetupService.setupStandardProperties(this);

    this.checkList = {items: this.createListItems()};
    this.checkListCommentControlTextField = {items: this.createCommentListItems()};

    this.setFieldActivation(false);

    this.setupChangeDetection();

  }

  onFieldValueChanged(fieldValue) {
    this.fieldValue = fieldValue;
    this.setFormValues(fieldValue);
    this.detectChanges();
  }

  setFieldActivation(shouldDetectChanges?) {
    this.checkList.items.controls.forEach((checkControl: FormControl) => {
      if (this.disabled) {
        checkControl.disable({emitEvent: false});
      } else {
        checkControl.enable({emitEvent: false});
      }
    });

    this.checkListCommentControlTextField.items.controls.forEach((commentControl: FormControl) => {
      if (this.disabled) {
        commentControl.disable({emitEvent: false});
      } else {
        commentControl.enable({emitEvent: false});
      }
    });

    this.detectChanges(shouldDetectChanges);

  }

  setFormValues(fieldValue) {
    if (fieldValue) {
      this.checkList.items.controls.map((checkControl, i) => {
        let isChecked = null;
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < fieldValue.length; j++) {
          if (this.componentDefinition.list[i] === fieldValue[j].item) {
            isChecked = fieldValue[j].checkedBool;
            break;
          }
        }
        if (checkControl.value != isChecked) {
          console.log(checkControl, fieldValue);
          checkControl.patchValue(isChecked);
        }
      });
      this.checkListCommentControlTextField.items.controls.map((commentControl, i) => {
        let commentValue = null;
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < fieldValue.length; j++) {
          if (this.componentDefinition.list[i] === fieldValue[j].item) {
            commentValue = fieldValue[j].comment;
            break;
          }
        }
        commentControl.patchValue(commentValue);

      });
    } else {
      this.checkList.items.controls.map((checkControl, i) => {
        checkControl.patchValue(false);
      });
      this.checkListCommentControlTextField.items.controls.map((commentControl, i) => {
        commentControl.patchValue(null);
      });
    }

  }

  createListItems() {
    const arr = this.componentDefinition.list.map(item => {
      const fldVal = this.document[this.componentDefinition.name];
      let value = null;
      if (fldVal && fldVal.length > 0) {
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < fldVal.length; j++) {
          if (item === fldVal[j].item) {
            value = fldVal[j].checkedBool ? fldVal[j].checkedBool : undefined;
            break;
          }
        }
      }
      return new FormControl(value);
    });
    return new FormArray(arr);
  }

  createCommentListItems() {
    const self = this;
    const arr = this.componentDefinition.list.map((item, i) => {
      const fldVal = this.document[this.componentDefinition.name];

      const commentObject = {
        item: item,
        checkedBool: undefined,
        comment: undefined,
        createdDate: undefined,
        createdBy: undefined
      };

      let value = null;
      if (fldVal && fldVal.length > 0) {
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < fldVal.length; j++) {
          if (item === fldVal[j].item) {
            if (fldVal[j].checkedBool) {
              commentObject.checkedBool = fldVal[j].checkedBool;
            }

            value = fldVal[j].comment;
            if (value) {
              commentObject.comment = value;
            }

            if (fldVal[j].createdDate) {
              commentObject.createdDate = fldVal[j].createdDate;
            }

            if (fldVal[j].createdBy) {
              commentObject.createdBy = fldVal[j].createdBy;
            }

            break;
          }
        }
      }
      self.commentItemList.push(commentObject);

      const commentFormControl = new FormControl(value);
      commentFormControl.valueChanges
        .pipe(debounceTime(400), distinctUntilChanged())
        .subscribe(query => {
          self.onChange(query).then(() => { }, () => { });
        });
      return commentFormControl;
    });
    return new FormArray(arr);
  }

  async onChange(key?) {
    let hasChange = false;
    let hasEmptyFieldValue = false;

    const compThis = this;
    const fldVal = this.document[this.componentDefinition.name];


    let checkListCommentValues: any = [];
    this.checkList.items.controls.map(async (item, i) => {
      let compValue = ((compThis.commentItemList[i].checkedBool === undefined
         || compThis.commentItemList[i].checkedBool === null) ? false
        : compThis.commentItemList[i].checkedBool);
      let itemValue = ((item.value === undefined || item.value === null) ? false : item.value);
      if (compValue != itemValue) {
        compThis.commentItemList[i].checkedBool = item.value;
        hasChange = true;
      }
    });

    this.checkListCommentControlTextField.items.controls.map(async (itemComment, counterComment) => {
      if (compThis.commentItemList[counterComment].comment != itemComment.value) {
        compThis.commentItemList[counterComment].comment = itemComment.value;
        hasChange = true;
      }

    });

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < compThis.commentItemList.length; i++) {
      if (compThis.commentItemList[i].checkedBool || compThis.commentItemList[i].comment) {
        if (fldVal && fldVal.length > 0) {
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < fldVal.length; j++) {
            if (compThis.commentItemList[i].item === fldVal[j].item) {
              if (compThis.commentItemList[i].createdDate != fldVal[j].createdDate) {
                compThis.commentItemList[i].createdDate = fldVal[j].createdDate;
                hasChange = true;
              }
              if (compThis.commentItemList[i].createdBy != fldVal[j].createdBy) {
                compThis.commentItemList[i].createdBy = fldVal[j].createdBy;
                hasChange = true;
              }

            }
          }
        }
        compThis.commentItemList[i].createdDate = compThis.commentItemList[i].createdDate ?
          compThis.commentItemList[i].createdDate : new Date().toISOString();
        const createdByObject = {documentId: compThis.user.documentId, name: compThis.user.systemHeader.summaryName};
        compThis.commentItemList[i].createdBy = compThis.commentItemList[i].createdBy ?
          compThis.commentItemList[i].createdBy : createdByObject;
        checkListCommentValues.push(compThis.commentItemList[i]);
      }
    }
    if (checkListCommentValues.length === 0) {
      checkListCommentValues = null;
      hasEmptyFieldValue = true;
    }
    // console.log(compThis.commentItemList, fldVal, compThis.document[compThis.fieldName], compThis.commentItemList[key], key
    //   , `hasChange = ${hasChange}`, `, hasEmtpyFieldValue = ${hasEmptyFieldValue}`);
    if (hasChange) {
      this.fieldValue = checkListCommentValues;
      if (hasEmptyFieldValue) {
        delete this.document[this.fieldName];
        this.valueChanged(undefined);
      } else {
        this.valueChanged(this.fieldValue);
      }


      console.log('commentChanges', JSON.stringify(this.fieldValue) );
    }

  }

  isEmptyObject(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }

}
